/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Menu, MenuList } from '@chakra-ui/react'
import { AiFillDashboard } from 'react-icons/ai'
import { BiTask } from 'react-icons/bi'
import { FaChevronDown, FaMapMarkerAlt, FaTrash } from 'react-icons/fa'
import { FaGear, FaPeopleGroup } from 'react-icons/fa6'
import { MdMailOutline } from 'react-icons/md'
import { TbDoorEnter, TbDoorExit } from 'react-icons/tb'
import { useLocation, useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { InfoTooltipCmp } from '../../../../../components/InfoTooltipCmp'
import { MenuButtonCmp } from '../../../../../components/MenuButtonCmp'
import { StyledMenuItem } from '../../../../../components/NavBar/Components/StyledMenuItem'
import { iCardFeedback } from '../../../../../interfaces'
import { parseJwt } from '../../../../../services/token'
import { ColumnText, PreViewParticipante, GridContainer } from './styles'

interface CardProps {
  feedback: iCardFeedback
  onDelete: () => void
}

export const CardFeedback: React.FC<CardProps> = ({ feedback, onDelete }) => {
  const nav = useNavigate()

  function ObterCorStatus(): string {
    if (feedback.status === 0) return 'var(--Yellow)'
    if (feedback.status > 0 && feedback.status < 4) return 'var(--Orange)'
    if (feedback.status === 4) return 'var(--Red)'
    if (feedback.status === 5) return 'var(--Green3)'

    return 'none'
  }

  return (
        <PreViewParticipante color={ObterCorStatus()}>
            <Box w={'.3rem'} h={'.3rem'} bg={ObterCorStatus()} borderRadius={'50%'} pos={'absolute'} top={'10px'} left={'10px'}></Box>
            <GridContainer>
                <ColumnText style={{ flex: 1 }}>
                    <Flex as={'span'} gap={'.625rem'} alignItems={'center'}><strong>{feedback.nome}</strong> {feedback.descricao && <InfoTooltipCmp VarColor={ObterCorStatus().replace('var(--', '').replace(')', '')} label={feedback.descricao}/>}</Flex>
                </ColumnText>

                <Flex alignItems={'center'} gap={'.325rem'}>
                    <FaPeopleGroup size={22} style={{ marginRight: '.25rem', color: 'var(--a5)' }} />
                    <ColumnText>
                        <h3>{feedback.participantes ?? 0}</h3>
                        <h4>Participantes</h4>
                    </ColumnText>
                </Flex>

                <Flex h={'2.25rem'} w={'2px'} bg={'var(--a5)'}></Flex>

                <Flex alignItems={'center'} gap={'.325rem'}>
                    <TbDoorEnter size={22} style={{ marginRight: '.25rem', color: 'var(--a5)' }} />
                    <ColumnText>
                        <h3>{feedback.entrada}</h3>
                        <h4>Informações prévias</h4>
                    </ColumnText>
                </Flex>

                <Flex h={'2.25rem'} w={'2px'} bg={'var(--a5)'}></Flex>

                <Flex alignItems={'center'} gap={'.325rem'}>
                    <BiTask size={22} style={{ marginRight: '.25rem', color: 'var(--a5)' }} />
                    <ColumnText>
                        <h3>{feedback.desenvolvimento}</h3>
                        <h4>Itens para condução</h4>
                    </ColumnText>
                </Flex>

            </GridContainer>
            <Flex alignItems={'center'} mx={'1rem'}>
                {(parseJwt().adm === 'True') && <Menu>
                    <MenuButtonCmp
                        Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }}/>}
                        VarColor='Green2'
                    >Opções
                    </MenuButtonCmp>
                    <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'}>
                        {feedback.iniciado === true && <StyledMenuItem
                        onClick={() => { if (feedback.colaboradorId) { nav(`${feedback.id}/Dashboard/${feedback.colaboradorId}/Participante`) } else { nav(`${feedback.id}/Dashboard`) } }}
                        >
                            <AiFillDashboard style={{ marginRight: '.375rem' }} size={'14'}/>
                            Dashboard
                        </StyledMenuItem>}
                        {
                            (parseJwt().adm === 'True' && feedback.status !== 5) && (
                                <>
                                    <StyledMenuItem
                                        onClick={() => nav(`${feedback.id}/Entrada`)}
                                    >
                                        <TbDoorEnter style={{ marginRight: '.375rem' }} size={'14'}/>
                                        Informações prévias
                                    </StyledMenuItem>
                                    {feedback.status > 0 && <StyledMenuItem
                                        onClick={() => nav(`${feedback.id}/Desenvolvimento`)}
                                    >
                                        <BiTask style={{ marginRight: '.375rem' }} size={'14'}/>
                                        Itens para condução
                                    </StyledMenuItem>}
                                    {feedback.status > 1 && <StyledMenuItem
                                    onClick={() => nav(`${feedback.id}/Participantes`)}
                                    >
                                        <FaPeopleGroup style={{ marginRight: '.375rem' }} size={'14'}/>
                                        Participantes
                                    </StyledMenuItem>}
                                    {feedback.status > 2 && <StyledMenuItem
                                    onClick={() => nav(`${feedback.id}/Envio`)}
                                    >
                                        <MdMailOutline style={{ marginRight: '.375rem' }} size={'14'}/>
                                        Gestão de envios
                                    </StyledMenuItem>}
                                </>
                            )
                        }
                        {
                            (parseJwt().adm === 'True') && (
                                <StyledMenuItem
                                    onClick={onDelete}
                                >
                                    <FaTrash style={{ marginRight: '.375rem' }} size={'14'}/>
                                    Excluir feedback
                                </StyledMenuItem>
                            )
                        }

                    </MenuList>
                </Menu>}
                {(parseJwt().adm !== 'True' && feedback.status > 3 && feedback.iniciado === true) && <ButtonCmp VarColor='Green2' leftIcon={<AiFillDashboard/>} onClick={() => { if (feedback.colaboradorId) { nav(`${feedback.id}/Dashboard/${feedback.colaboradorId}/Participante`) } else { nav(`${feedback.id}/Dashboard`) } }}>Dashboard</ButtonCmp>}
            </Flex>
        </PreViewParticipante>
  )
}
